import { useRef } from 'react';

export interface DraftIdentity {
  session: object;
  gameId: string | null;
  matchId: string | null;
  seat: string | null;
}

/** Transport and revision are deliberately excluded. Existing decision/domain
 * retention rules still govern revisions; a different identity never owns old answers. */
export function sameDraftIdentity(a: DraftIdentity, b: DraftIdentity): boolean {
  return a.session === b.session && a.gameId === b.gameId && a.matchId === b.matchId && a.seat === b.seat;
}

export function useDraftContext(identity: DraftIdentity): number {
  const boundary = useRef({ identity, epoch: 0 });
  if (!sameDraftIdentity(boundary.current.identity, identity)) {
    boundary.current = { identity, epoch: boundary.current.epoch + 1 };
  }
  return boundary.current.epoch;
}
